module.exports = __webpack_public_path__ + "static/gnome-ranger-swarmkeeper-ed87483f029dab693155afa7af24d758.png";